"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.manuallyFocusElement = manuallyFocusElement;

function manuallyFocusElement(className) {
  ;
  document.querySelector('.' + className).focus();
}